import { pb } from '@/libs/pocketbase'
import type {
	Notification,
	NotificationLevel,
	NotificationsFeedPort,
	NotificationVariant,
} from '../domain/notification'

type PbPayload = {
	message: string
	title?: string
	level: NotificationLevel
	variant: NotificationVariant
	duration?: number
}

type PbNotification = {
	id: string
	user_id: string
	event_type: string
	payload: PbPayload
	read: boolean
	created: string
}

type PbListResult<T> = {
	items: T[]
	page: number
	perPage: number
	totalItems: number
	totalPages: number
}

const toNotification = (record: PbNotification): Notification => ({
	id: record.id,
	message: record.payload.message,
	title: record.payload.title,
	level: record.payload.level,
	variant: record.payload.variant,
	duration: record.payload.duration,
	status: record.read ? 'read' : 'unread',
	createdAt: record.created,
})

const pbNotificationsFeed: NotificationsFeedPort = {
	subscribe: async (_userId, onNotification) => {
		const raw = await pb.send<PbListResult<PbNotification> | PbNotification[] | null>('/api/notifications', { method: 'GET', requestKey: null })
		const existing: PbNotification[] = Array.isArray(raw) ? raw : (raw?.items ?? [])

		for (const record of [...existing].reverse()) {
			onNotification(toNotification(record))
		}

		await pb.collection('notifications').subscribe<PbNotification>('*', ({ action, record }) => {
			if (action === 'create') {
				onNotification(toNotification(record))
			}
		})

		return () => {
			pb.collection('notifications').unsubscribe('*')
		}
	},
}

export { pbNotificationsFeed }
